import { render, staticRenderFns } from "./play-video.vue?vue&type=template&id=6c493f1a&"
import script from "./play-video.vue?vue&type=script&lang=js&"
export * from "./play-video.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports